<template>
    <nav class="nav-section">
        <navbar-drawer :is-show-drawer.sync="isShowDrawer" />
        <v-app-bar app absolute class="nav-tabs-bar" :height="appBarHeight">
            <v-tabs
                color="#2960e8"
                background-color="transparent"
                :slider-color="
                    ['home', 'contact', 'page-not-found'].includes($route.name)
                        ? 'transparent'
                        : '#2960e8'
                "
                v-model="selectedTab"
            >
                <v-tab
                    :to="{ name: 'home' }"
                    class="home-link-tab home-link"
                    :ripple="false"
                    :data-ga="`${gaPrefix}logo`"
                >
                    <img class="logo" src="@/assets/logo.png" alt="logo" />
                </v-tab>
                <v-tab
                    class="nav-tab d-none d-sm-flex"
                    text
                    v-for="navItem in NavItems.left"
                    :key="navItem.routeName"
                    :to="{ name: navItem.routeName }"
                    :ripple="false"
                    :data-ga="`${gaPrefix}${navItem.displayName}`"
                    >{{ navItem.displayName }}</v-tab
                >
                <v-tab
                    class="nav-tab d-none d-sm-flex"
                    text
                    :key="NavItems.cart.routeName"
                    active-class=""
                    :to="{ name: NavItems.cart.routeName }"
                    :ripple="false"
                    :data-ga="`${gaPrefix}${NavItems.cart.displayName}`"
                >
                    <manage-card
                        :actions="NavItems.manage"
                        @input="selectAction = $event"
                    />
                </v-tab>
                <v-tab
                    class="nav-tab d-none d-sm-flex"
                    text
                    :key="NavItems.support.routeName"
                    :to="{ name: NavItems.support.routeName }"
                    :ripple="false"
                    :data-ga="`${gaPrefix}${NavItems.support.displayName}`"
                    >{{ NavItems.support.displayName }}</v-tab
                >

                <div class="flex-grow-1"></div>
                <v-tab
                    class="right-tab d-none d-sm-flex"
                    text
                    v-for="navItem in NavItems.right"
                    :key="navItem.routeName"
                    :to="{ name: navItem.routeName }"
                    :ripple="false"
                    :data-ga="`${gaPrefix}business`"
                    >{{
                        $vuetify.breakpoint.lgAndUp
                            ? navItem.displayNameLong
                            : navItem.displayNameShort
                    }}</v-tab
                >
            </v-tabs>

            <v-app-bar-nav-icon class="d-sm-none" @click.stop="toggleNavBar"
                ><img
                    v-if="!isShowDrawer"
                    src="@/assets/hamburger.svg"
                    height="18px"
                    width="24px"
                    alt="logo"
                    :data-ga="`${gaPrefix}hamburger`"
            /></v-app-bar-nav-icon>
        </v-app-bar>
        <notification-bar :top-position="appBarHeight"></notification-bar>
    </nav>
</template>

<script>
import NavItems from '@/NavItems';
import NotificationBar from '@/components/notification-bar';
import ManageCard from '@/components/Nav/manage-card';
import NavbarDrawer from '@/components/Nav/navbar-drawer';
import { MANAGE_CARDS } from '@/constatns';

export default {
    name: 'page-nav',
    components: {
        ManageCard,
        NotificationBar,
        NavbarDrawer,
    },
    data: () => ({
        isShowDrawer: false,
        selectedTab: undefined,
        gaPrefix: 'Top Navigation|',
        selectAction: MANAGE_CARDS,
    }),
    computed: {
        NavItems() {
            return NavItems;
        },
        appBarHeight() {
            return this.$vuetify.breakpoint.xsOnly ? '52px' : '60px';
        },
    },
    methods: {
        toggleNavBar() {
            this.isShowDrawer = !this.isShowDrawer;
        },
    },
};
</script>

<style lang="scss" scoped>
.nav-section {
    .drawer-section {
        text-align: center;
        overflow: visible;
        .drawer-close-btn {
            position: absolute;
            top: 8px;
            left: -48px;
            .v-icon {
                font-size: 34px;
            }
        }
        .drawer-close-btn.v-btn {
            &:before {
                background-color: transparent;
            }
            &:hover {
                background-color: transparent;
            }
        }
        .drawer-logo {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 60px;
        }
        .drawer-list-group {
            background-color: #f6f6f6;
            width: 100%;
            height: calc(100vh - 60px);
            .drawer-list-top {
                padding-top: 20px;
                .drawer-list-item {
                    padding: 10px;
                    .list-title {
                        font-weight: 500;
                        font-size: 14px;
                        text-transform: uppercase;
                        letter-spacing: normal;
                    }
                }
                .v-list-item {
                    &:before {
                        background: transparent;
                    }
                    &:hover {
                        color: #2960e8 !important;
                    }
                }
                .v-list-item--active {
                    color: #2960e8 !important;
                }
            }
            .drawer-list-bottom {
                .list-title {
                    color: #7b7b7b;
                    font-size: 13px;
                    text-transform: uppercase;
                    letter-spacing: normal;
                }
                .v-list-item--link {
                    &:before {
                        background: transparent;
                    }
                }
            }

            .drawer-divider-wrapper {
                width: 100%;
                display: flex;
                justify-content: center;
                padding: 10px;
                .drawer-divider {
                    width: 16px;
                    height: 1px;
                    border-radius: 1.5px;
                    background-color: #7b7b7b;
                }
            }
        }
    }
    .nav-tabs-bar {
        padding: 0 30px;
        .home-link-tab {
            padding-right: 40px;
        }
        .nav-tab {
            &.v-tab:not(.v-tab--active) {
                color: #3f3f3f;
            }
            &.v-tab.v-tab--active {
                font-weight: bold;
                color: #2960e8;
            }
            margin-right: 20px;
            font-size: 13px;
            padding: 0;
        }
        .right-tab {
            padding: 1px 0 0 0;
            font-size: 13px;
            font-weight: 500;
            color: #3f3f3f !important;
        }
    }
    .logo {
        height: 30px;
    }
}

// custom modification from Vuetify default style
.v-app-bar {
    opacity: 0.9;
    box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.11);
    .v-tab {
        min-width: 0;
        &:hover {
            color: #2960e8 !important;
        }
        &:before {
            background-color: transparent !important;
        }
    }
}

@include break('lg') {
    .nav-section {
        .nav-tabs-bar {
            padding: 0 58px;
            .home-link-tab {
                padding-right: 60px;
            }
            .nav-tab {
                margin-right: 30px;
                font-size: 14px;
            }
            .right-tab {
                font-size: 14px;
            }
        }
    }
}
</style>

<style lang="scss">
.v-app-bar {
    .v-toolbar__content {
        padding: 0;
    }
    &.bar-full {
        .v-toolbar__content {
            padding-left: 58px;
            padding-right: 58px;
        }
    }
    .v-btn {
        letter-spacing: normal;
        &:hover:before,
        &:focus:before {
            color: transparent;
            transition: none;
        }
        &:hover,
        &:focus {
            color: #2960e8;
        }
        &:before {
            transition: none;
        }
        &.v-btn--active {
            color: #2960e8;
            &:before {
                color: transparent;
            }
        }
    }
}

// remove nav bar left arror tab
.v-tabs-bar.v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows):not(.v-slide-group--has-affixes)
    .v-slide-group__prev {
    display: none !important;
}
@include break('xl') {
    .nav-section .nav-tabs-bar .v-toolbar__content {
        max-width: 1920px;
        margin: 0 auto;
        padding: 0 58px;
    }
}
</style>
